import {AbstractControl, AsyncValidatorFn, ValidationErrors} from '@angular/forms';
import {Observable, of} from 'rxjs';
import {ApiService} from '../../../_services/api.service';
import {catchError, map} from 'rxjs/operators';
import {CustomFormControl} from '../components/controls/CustomFormControl';

export function asyncPersonalPropertyValidator(apiService: ApiService): AsyncValidatorFn {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    if (!(control instanceof CustomFormControl)) {
      return;
    }

    const assessment = control.value.replace(/-/g, '').toUpperCase();

    return apiService.getAssessmentType(assessment).pipe(
      map(assessmentType => {
        control.markAsTouched({onlySelf: true});

        if (assessmentType.propertyType === null) {
          return {invalidAin: true};
        }

        if (assessmentType.propertyType === 'RP' || assessmentType.propertyType === 'CR') {
          return {notPersonalPropertyIsRealProperty: true};
        }

        return null;
      }),
      catchError((error: any) => {
        console.error(error);
        control.markAsTouched({onlySelf: true});
        return of({invalidAin: true});
      })
    );
  };
}
